var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    xmlSpace: "preserve",
    y: 0,
    x: 0,
    id: "Layer_1",
    viewBox: "-47.2164 -60.01525 409.2088 360.0915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style13635",
    type: "text/css"
  }, ".st1{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.004 .057)",
    id: "g13647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13637",
    d: "M27 209.6c2.5 2.3 5.2 4.4 7.9 6.4 12.8 9.2 28.4 15.9 45.8 19.9 18.8 4.2 38.3 5 57.4 3.2 8.6-.8 17.1-2.2 25.6-4 11.4-2.4 22.6-5.8 33.4-9.9 5.5-2.1 11-4.4 16.3-6.9 12.6-5.9 24.7-12.9 36-21 3.8-2.8 7.6-5.6 11.2-8.7 4.4-3.7 8.7-7.5 12.8-11.6 3.4-3.4 6.6-6.8 9.7-10.5 2.6-3 5.1-6.2 7.5-9.4 11.1-15.1 18.7-31.2 22.1-47.3 3.5-16.2 2.7-33.5-3.3-48.8-1.7-4.2-3.7-8.3-6-12.2-3.2-5.2-6.9-10-11.1-14.4-1.5-1.5-3.1-2.8-4.6-4.2-1.7-1.5-3.4-2.9-5.2-4.3-3.7-2.9-7.6-5.5-11.6-7.8-11.4-6.6-24.1-11.2-37-14.1C216.6.1 198.7-.8 181.1.5c-9.7.7-19.4 2.1-28.9 4.2-11.7 2.5-23.3 5.9-34.5 10.2-5.3 2-10.3 4.2-15.3 6.5-16.7 7.7-31.7 16.9-44.8 27.4-2.9 2.3-5.6 4.6-8.4 7.1-1.6 1.4-3.2 2.8-4.7 4.3-4.4 4.2-8.5 8.4-12.5 13-2.9 3.4-5.7 6.9-8.4 10.6-9.7 13.5-17.4 28.7-21.2 45-3.7 16.3-3.3 33.4 2.5 49l1.5 3.6c1.5 3.5 3.3 6.9 5.4 10.2 2.1 3.3 4.4 6.5 6.9 9.5 2.6 3 5.3 5.9 8.3 8.5",
    fill: "#ce0000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g13645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13639",
    d: "M265 79c-.3-.2-.8-.2-1.7-.1-1.6.2-11.5 1.2-15.8 1.6-1.8.2-2.6.9-3.4 2.3-.8 1.3-22.6 38.5-22.6 38.5s16.6-89.6 17.1-92.1c.6-3.1 0-3.8-2.4-3.8-2.5 0-13.8 1.3-15.5 1.5-2.2.3-3 1-3.5 3.8-.4 2.1-24.7 134.7-25.1 137.1-.7 3.8-.6 3.9 2.8 3.3 2-.3 11.6-1.9 15.7-2.5 1.2-.2 1.9-.2 2.3-2.1.4-1.9 7.8-40.8 7.8-40.8s12.5 35.6 13.1 37.1c.5 1.4.9 1.9 2.7 1.6 4.5-.7 14.8-2.4 15.8-2.6 1.8-.3 2.1-.8 1.6-2.3-.5-1.6-13.3-38.4-13.3-38.4s23.6-38.8 24.5-40.4c.4-.7.4-1.4-.1-1.7z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13641",
    d: "M189.5 88.8c-3.1-1.2-9.5-3.1-17.1-2.2-11.4 1.3-19.4 6.3-23.5 14.1-4.2 7.9-3.5 16.7-2.1 21.1 1.4 4.4 5 9.5 10 13.8 11 9.7 10.7 17.2 9.1 20.4-1.9 3.9-7.4 7-14.9 5.4-7.5-1.6-9.9-6.5-9.9-6.5s-3.7 12.9-4.4 15.4c-1 3.4-.6 4.4 2.6 5.7 4.2 1.7 12.3 3.6 25.4 1 9-1.7 17-8.8 20.9-16.2 4-7.6 6.5-22.5-6.1-33.8-10.2-9.2-11.3-10.8-12.4-12.8-2-3.6-.4-7.9 1.5-10.2 1.7-2.1 3.9-3.1 7.5-2.9 3.6.2 10 5 10 5s4.6-12.9 4.9-14c.6-1.5.2-2.7-1.5-3.3z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13643",
    d: "M120.4 46.4c-.3-4-3.5-3.2-5-.3-4.9 9.8-71.4 143.6-72.2 145.3-1.2 2.4-.2 2.8 2.1 2.5 1.7-.2 16.4-2.5 20.8-3.2 1.5-.2 2-.5 2.5-1.6.2-.6 10.7-24.7 10.7-24.7l29.3-4.5s.3 18.5.3 21.7c0 1.4.1 2.3 2.6 1.9 2.8-.4 14.3-2.2 15.9-2.5 2.9-.5 3.2-1.2 3-3.8-.1-1.8-9.2-121.4-10-130.8zm-33.2 98.9l21.3-49 .2 45.7z",
    className: "st1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/ask.40da00c52c216d09a39fa5e7fc47b685.svg";
export { ForwardRef as ReactComponent };